import React from "react";
import {
    Card,
    CardContent,
    Alert,
    AlertTitle,
    Box
} from "@mui/material";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import Typography from "@mui/material/Typography";
import ErrorRoundedIcon from '@mui/icons-material/ErrorRounded';

type WarningBannerProps = {
    message: string;
    title?: string;
    severity?: 'warning' | 'error'
};

const WarningBanner: React.FC<WarningBannerProps> = ({message, title, severity='warning'}) => {
    const icons = {
        "warning": <WarningAmberRoundedIcon fontSize="medium" color={severity} />,
        "error": <ErrorRoundedIcon fontSize="medium" color={severity}/>
    }

    return (
        <Card
            elevation={3}
            sx={{
                width: "100%",
                borderRadius: 3,
            }}
        >
            <CardContent >
                <Alert
                    severity={severity}
                    icon={icons[severity] || <></>}
                    sx={{
                        padding: "0px",
                        alignItems: "center",
                        width: "100%",
                        backgroundColor: "transparent",
                        "& .MuiAlert-message": {
                            width: "100%",
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                            whiteSpace: "nowrap",
                        },
                    }}
                >
                    <Box>
                        <AlertTitle sx={{fontWeight: 600 }}>
                            {title}: <Typography component={'span'}>{message}</Typography>
                        </AlertTitle>
                    </Box>
                </Alert>
            </CardContent>
        </Card>
    );
};

export default WarningBanner;